import React from 'react'
import _ from 'lodash'
import propTypes from 'prop-types'
import classNames from 'classnames'
import { FaInbox } from 'react-icons/fa'
import InfiniteScroll from 'react-infinite-scroller'

import { Album } from './Album'
import FullScreenMessage from 'components/FullScreenMessage'
import Loader from 'components/Loader'


export function Albums(props) {
  if (!props.loading && props.items.length === 0) {
    return (
      <FullScreenMessage icon={<FaInbox className='text-4xl' />}>
        <span>No albums found.</span>
      </FullScreenMessage>
    )
  }

  return (
    <div
      className={classNames([
        '',
        props.className,
      ])}
    >
      <InfiniteScroll
        className='pb-20 albums grid gap-1 grid-cols-2 lg:grid-cols-7 sm:grid-cols-4 items-center'
        loadMore={props.loadMore}
        hasMore={props.hasMore}
        loader={
          props.items.length !== 0 &&
          <div key={0} className='text-center'>
            <Loader className='text-center inline-block' active />
          </div>
        }
      >
        {
          _.map(
            _.orderBy(props.items, 'createdAt', 'desc'),
            album => {
              return (
                <div key={`album_${album.id}`} className='flex-grow'>
                  <Album {...album} />
                </div>
              )
            }
          )
        }
      </InfiniteScroll>
    </div>
  )
}

Albums.propTypes = {
  items: propTypes.array.isRequired,
  loading: propTypes.bool,
  className: propTypes.string,
  hasMore: propTypes.bool.isRequired,
  loadMore: propTypes.func.isRequired,
}

Albums.defaultProps = {
  loading: false,
}
